export const AnalyticsIDs: Record<string, string> = {
  pesdk: 'PESDKDocs',
  vesdk: 'VESDKDocs',
  cesdk: 'CESDKDocs',
  pricing: 'Pricing',
  contactSales: 'ContactSales',
  freeTrial: 'FreeTrial',
  faq: 'FAQ',
  instagram: 'Instagram',
  linkedIn: 'LinkedIn',
  twitter: 'Twitter',
  github: 'GitHub',
  googlePlay: 'Google-Play-Outbound',
  appStore: 'AppStore-Outbound',
  showcases: 'Showcases',
};

const PESDK = {
  name: 'PhotoEditor SDK',
  url: 'https://img.ly/photo-sdk',
};
const VESDK = {
  name: 'VideoEditor SDK',
  url: 'https://img.ly/video-sdk',
};
const CESDK = {
  name: 'CreativeEditor SDK',
  url: 'https://img.ly/creative-sdk',
};

const CompanySDK = { name: 'Products', items: [PESDK, VESDK, CESDK] };

const PESDKDocs = [
  // first item is the title
  { name: 'PhotoEditor SDK', url: null },
  { name: 'Get Started', url: 'https://img.ly/docs/pesdk/' },
  { name: 'Guides', url: 'https://img.ly/docs/pesdk/guides/' },
  { name: 'Frameworks', url: 'https://img.ly/docs/pesdk/quickstarts/' },
  { name: 'API Reference', url: 'https://img.ly/docs/pesdk/apidocs/' },
];

const VESDKDocs = [
  { name: 'VideoEditor SDK', url: null },
  { name: 'Get Started', url: 'https://img.ly/docs/vesdk/' },
  { name: 'Guides', url: 'https://img.ly/docs/vesdk/guides/' },
  { name: 'Frameworks', url: 'https://img.ly/docs/vesdk/quickstarts/' },
  { name: 'API Reference', url: 'https://img.ly/docs/vesdk/apidocs/' },
];

const CESDKDocs = [
  { name: 'CreativeEditor SDK', url: null },
  { name: 'Get Started', url: 'https://img.ly/docs/cesdk/' },
  { name: 'Guides', url: 'https://img.ly/docs/cesdk/platforms/' },
  { name: 'Frameworks', url: 'https://img.ly/docs/cesdk/frameworks/' },
];

const Support = { name: 'Support Desk', url: 'https://img.ly/support' };
const ContactSupport = {
  name: 'Visit our Support Desk',
  url: 'https://img.ly/support',
};
const Pricing = {
  name: 'Pricing',
  url: 'https://img.ly/pricing',
  analyticsID: AnalyticsIDs.pricing,
};
const Blog = { name: 'Blog', url: 'https://img.ly/blog' };
const ContactSales = {
  name: 'Contact Sales',
  url: 'https://img.ly/forms/contact-sales',
  analyticsID: AnalyticsIDs.contactSales,
};
const FreeTrial = {
  name: 'Free Trial',
  url: 'https://img.ly/forms/free-trial',
  analyticsID: AnalyticsIDs.freeTrial,
};
const SignIn = { name: 'Sign In', url: 'https://img.ly/login' };
const FAQS = {
  name: 'FAQs',
  url: 'https://img.ly/faqs',
  analyticsID: AnalyticsIDs.faq,
};
const AviaryAlternative = {
  name: 'Aviary Alternative',
  url: 'https://img.ly/imgly-aviary-comparison',
};
const Showcases = {
  name: 'Showcases',
  url: 'https://img.ly/showcases/cesdk/web',
  analyticsID: AnalyticsIDs.showcases,
};

const Resources: { name: string; url: string; analyticsID?: string }[] = [
  SignIn,
  Blog,
  FAQS,
  AviaryAlternative,
  Support,
];

const Company = [
  { name: 'About Us', url: 'https://img.ly/company' },
  { name: 'Customers', url: 'https://img.ly/customers' },
  { name: 'Team', url: 'https://img.ly/company/team' },
  { name: 'Careers', url: 'https://img.ly/company/careers' },
  { name: 'Contact Us', url: 'https://img.ly/company/contact-us' },
];

const Legal = [
  { name: 'Terms', url: 'https://img.ly/tos' },
  { name: 'Imprint', url: 'https://img.ly/imprint' },
  { name: 'Privacy', url: 'https://img.ly/privacy-policy' },
  { name: 'Privacy Policy', url: 'https://img.ly/de/privacy-policy' },
  { name: 'Acknowledgements', url: 'https://img.ly/acknowledgements' },
];

const DocsMenuItems = [
  {
    id: 'pesdk',
    name: 'PhotoEditor SDK',
    shortName: 'PE.SDK',
    url: 'https://img.ly/docs/pesdk',
  },
  {
    id: 'vesdk',
    name: 'VideoEditor SDK',
    shortName: 'VE.SDK',
    url: 'https://img.ly/docs/vesdk',
  },
  {
    id: 'cesdk',
    name: 'CreativeEditor SDK',
    shortName: 'CE.SDK',
    url: 'https://img.ly/docs/cesdk',
  },
];

const FooterDeveloperLinks: Record<
  string,
  { name: string; url: string | null }[]
> = {
  pesdk: PESDKDocs,
  vesdk: VESDKDocs,
  cesdk: CESDKDocs,
};

export const Links = {
  PESDK,
  VESDK,
  CESDK,
  CompanySDK,
  PESDKDocs,
  VESDKDocs,
  CESDKDocs,
  Support,
  ContactSupport,
  Pricing,
  Blog,
  ContactSales,
  FreeTrial,
  SignIn,
  FAQS,
  AviaryAlternative,
  Company,
  Resources,
  Legal,
  DocsMenuItems,
  FooterDeveloperLinks,
  Showcases,
};
